import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BannerProvider } from "@playcharge/common/models/backend/banners/banner-provider";
import { Nullable } from "@playcharge/common/models/backend/nullable";
import { CommonModule } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { ClientEditModel } from "@playcharge/common/models/backend/clients/client-edit-model";
import { ClientViewModel } from "@playcharge/common/models/backend/clients/client-view-model";
import { OfferSourceType } from "@playcharge/common/models/backend/offers/offer-source-type";

@Component({
    selector: "app-edit-client-dialog",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatChipsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatButton,
    ],
    templateUrl: "./edit-client-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditClientDialogComponent implements OnInit {
    private _selfRef: MatDialogRef<EditClientDialogComponent, ClientEditModel> = inject(
        MatDialogRef<EditClientDialogComponent, ClientEditModel>,
    );

    private _data: Nullable<ClientViewModel> = inject(MAT_DIALOG_DATA);

    public form = new FormGroup({
        id: new FormControl<number>(0, { nonNullable: true }),
        sourceType: new FormControl<OfferSourceType>(OfferSourceType.Internal, {
            nonNullable: true,
        }),
        title: new FormControl<string>("", {
            nonNullable: true,
            validators: [Validators.required],
        }),
        securePostbackCode: new FormControl<Nullable<string>>(null),
    });

    public ngOnInit(): void {
        if (this._data) {
            this.form.patchValue(this._data);

            if (this._data.sourceType === OfferSourceType.Affise) {
                this.form.controls.title.disable();
                this.form.controls.securePostbackCode.disable();
            }
        }
    }

    public close(): void {
        this._selfRef.close(this.form.getRawValue());
    }
}
